import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.regexp.to-string.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, Text, Tooltip, TextField } from '@hub-la/design-system';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import 'react-phone-number-input/style.css';
import { useField } from '../hooks/use-field.js';
import { PhoneNumberStyled } from './fields/phone-number-styled.js';

const CpfForm = () => {
  const {
    values,
    handleBlur,
    handleChange,
    setFieldValue
  } = useFormikContext();
  const {
    hasError,
    getErrorText
  } = useField();
  const {
    t
  } = useTranslation();
  return jsxs(Stack, Object.assign({
    direction: "column",
    spacing: 4
  }, {
    children: [jsxs(Stack, Object.assign({
      direction: "row",
      spacing: 1
    }, {
      children: [jsx(Text, {
        children: t('accountVerification.form.cpf.label')
      }), jsx(Tooltip, Object.assign({
        trigger: "hover",
        title: jsx(Text, {
          children: t('accountVerification.form.cpf.tooltip')
        }),
        arrow: true
      }, {
        children: jsx(InfoOutlinedIcon, {})
      }))]
    })), jsxs(Stack, Object.assign({
      direction: "column",
      spacing: 4
    }, {
      children: [jsx(TextField, {
        error: hasError('businessOwner.fullName'),
        helperText: getErrorText('businessOwner.fullName'),
        onBlur: handleBlur,
        onChange: handleChange,
        value: values.businessOwner.fullName,
        type: "fullName",
        id: "businessOwner.fullName",
        size: "normal",
        label: t('fullName')
      }), jsx(NumberFormat, {
        error: hasError('businessOwner.documentNumber'),
        helperText: getErrorText('businessOwner.documentNumber'),
        onBlur: handleBlur,
        onChange: handleChange,
        value: values.businessOwner.documentNumber,
        type: "tel" // numbers only
        ,
        id: "businessOwner.documentNumber",
        size: "normal",
        label: t('cpf'),
        format: "###.###.###-##",
        customInput: TextField,
        fullWidth: true
      }), jsx(TextField, {
        error: hasError('businessOwner.email'),
        helperText: getErrorText('businessOwner.email'),
        onBlur: handleBlur,
        onChange: handleChange,
        value: values.businessOwner.email,
        type: "email",
        id: "businessOwner.email",
        size: "normal",
        label: t('email')
      }), jsx(PhoneNumberStyled, {
        error: hasError('businessOwner.phoneNumber'),
        helperText: getErrorText('businessOwner.phoneNumber'),
        onBlur: handleBlur,
        onChange: value => value && setFieldValue('businessOwner.phoneNumber', value.toString()),
        value: values.businessOwner.phoneNumber,
        id: "businessOwner.phoneNumber",
        label: t('phoneNumber')
      })]
    }))]
  }));
};

export { CpfForm };
